import React from "react";

function NoData() {
    return (
        <div className="no-result">
           
            <div className="text">No Data</div>
        </div>
    );
}
export default NoData;